<template>
  <section class="catalog_head_outer">
    <div class="container">
      <div class="page_head">
        <bread-crumbs></bread-crumbs>
        <div class="flx">
          <h2>Акции</h2>
          <div class="pagination_head flx">
            <items-per-page :value.sync="perPage" :items="perPageItems"></items-per-page>
<!--            <items-sort-by v-if="isAuth()" :items="itemsSortBy" :sort-by.sync="sortBy" :sort-direction.sync="sortDirection"></items-sort-by>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BreadCrumbs from '../../BreadCrumbs/BreadCrumbs'
import ItemsPerPage from '../../Pagination/ItemsPerPage'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'StockHeadOuter',
  inject: ['isAuth'],
  components: {
    BreadCrumbs,
    ItemsPerPage
  },
  computed: {
    ...mapState('catalog', {
      per_page: 'perPage',
      perPageItems: 'perPageItems',
      itemsSortBy: 'itemsSortBy',
      sort_by: 'sortBy',
      sort_direction: 'sortDirection'
    }),
    ...mapGetters('catalog', ['getBreadCrumbs']),
    perPage: {
      get () { return parseInt(this.per_page) },
      set (val) {
        this.setPerPage(parseInt(val))
        this.$nextTick(() => {
          this.getStocks()
        })
      }
    },
    sortBy: {
      get () { return this.sort_by },
      set (val) {
        this.setSortBy(val)
        this.$nextTick(() => {
          this.getStocks()
        })
      }
    },
    sortDirection: {
      get () { return this.sort_direction },
      set (val) {
        this.setSortDirection(val)
      }
    }
  },
  methods: {
    ...mapMutations('catalog', ['setSortBy', 'setSortDirection', 'setPerPage']),
    ...mapActions('products', ['getStocks'])
  }
}
</script>

<style scoped>

</style>
